import { create } from "zustand";

const useLearnerOnboardingStore = create((set) => ({
    // wantsToBuyLearnerPass: false,
    // setWantsToBuyLearnerPass: (wantsToBuyLearnerPass) =>
    //     set({ wantsToBuyLearnerPass }),
}));

export default useLearnerOnboardingStore;